import { useState } from 'react';
import { Ruler } from 'lucide-react';
import { findSizeByMeasurement } from '../../utils/convertSize';
import FootLengthRuler from './FootLengthRuler';

export default function MeasurementFinder({ t, categoryId, gender, onResult }) {
  const [cm, setCm] = useState('');
  const [measureType, setMeasureType] = useState('chest');

  const isFootCategory = categoryId === 'shoes' || categoryId === 'kids-shoes';
  const isJeans = categoryId === 'jeans';
  const showWaist = !isFootCategory && isJeans;
  const rulerMin = categoryId === 'kids-shoes' ? 16 : 22;
  const rulerMax = categoryId === 'kids-shoes' ? 25 : 32;

  const handleFind = () => {
    const result = findSizeByMeasurement({
      categoryId,
      gender,
      measurementType: showWaist ? 'waist' : measureType,
      cmValue: cm,
    });
    if (result) onResult(result);
  };

  return (
    <div className="rounded-xl border border-dashed border-emerald-600/40 bg-emerald-950/20 p-4">
      <div className="flex items-center gap-2 mb-3">
        <Ruler className="w-4 h-4 text-emerald-400" />
        <h3 className="text-sm font-semibold text-emerald-300">{t.measureFinder.title}</h3>
      </div>
      <p className="text-xs text-slate-400 mb-3">{t.measureFinder.hint}</p>

      {!isFootCategory && !isJeans && (
        <div className="flex gap-2 mb-3">
          {['chest', 'waist'].map((type) => (
            <button
              key={type}
              type="button"
              onClick={() => setMeasureType(type)}
              className={`rounded-full px-3 py-1 text-xs border ${
                measureType === type
                  ? 'border-emerald-500 text-emerald-300 bg-emerald-500/10'
                  : 'border-slate-600 text-slate-400'
              }`}
            >
              {t.measureFinder[type]}
            </button>
          ))}
        </div>
      )}

      <div className="flex flex-col sm:flex-row gap-2">
        <div className="relative flex-1">
          <input
            type="number"
            min="1"
            max="250"
            step="0.5"
            value={cm}
            onChange={(e) => setCm(e.target.value)}
            placeholder={
              isFootCategory
                ? t.measureFinder.footPlaceholder
                : t.measureFinder.bodyPlaceholder
            }
            className="w-full rounded-lg border border-slate-600 bg-slate-900 px-4 py-2.5 text-white pr-12 focus:border-emerald-500 focus:outline-none"
          />
          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-500 text-sm">
            cm
          </span>
        </div>
        <button
          type="button"
          onClick={handleFind}
          disabled={!cm}
          className="rounded-lg bg-emerald-600 hover:bg-emerald-500 disabled:opacity-40 px-5 py-2.5 text-sm font-semibold text-white whitespace-nowrap"
        >
          {t.measureFinder.find}
        </button>
      </div>

      {isFootCategory && (
        <FootLengthRuler
          t={t}
          value={cm || String(rulerMin)}
          onChange={setCm}
          min={rulerMin}
          max={rulerMax}
        />
      )}
    </div>
  );
}
